export default "/build/images/maps.png?e89cbb1833074affb15908e36b2fc089";